import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Separator } from "@/components/ui/separator";

import { cn } from "@/lib/utils";

const sentimentOptions = ["All", "Positive", "Negative", "Neutral"] as const;
const channelOptions = ["All", "Instagram", "Facebook"] as const;

export type SentimentValue = (typeof sentimentOptions)[number];
export type ChannelValue = (typeof channelOptions)[number];
export type FilterValue = SentimentValue | ChannelValue;

type FiltersProps = {
  sentimentValue?: SentimentValue;
  onSentimentChange?: (value: SentimentValue) => void;
  channelValue?: ChannelValue;
  onChannelChange?: (value: ChannelValue) => void;
  className?: string;
};

export function Filters({ sentimentValue = "All", onSentimentChange, channelValue = "All", onChannelChange, className }: FiltersProps) {
  return (
    <div className={cn("flex gap-3 items-center w-1/3", className)} role="group" aria-label="Filter options">
      <Select value={sentimentValue} onValueChange={(v) => onSentimentChange?.(v as SentimentValue)}>
        <SelectTrigger className="w-1/2">
          <SelectValue placeholder="Sentiment" />
        </SelectTrigger>
        <SelectContent>
          {sentimentOptions.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Separator orientation="vertical" className="data-[orientation=vertical]:h-6" />
      <Select value={channelValue} onValueChange={(v) => onChannelChange?.(v as ChannelValue)}>
        <SelectTrigger className="w-1/2">
          <SelectValue placeholder="Channel" />
        </SelectTrigger>
        <SelectContent>
          {channelOptions.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
